/**
 * Helper functions serialize.js
 *
 * @namespace serialize
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/helper/serialize.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

/**
 * @function serialize.deserializeNullString
 */
export const deserializeNullString = (string) => {
  if (string === 'null' || string === 'undefined') return null
  return string ?? ''
}

/**
 * @function serialize.deserializeNullJSON
 */
export const deserializeNullJSON = (string) => {
  if (string === 'null' || string === 'undefined') return null
  return JSON.parse(string)
}